import { render } from "./PaymentMethodModal.vue?vue&type=template&id=3ae1c1b8&scoped=true"
import script from "./PaymentMethodModal.vue?vue&type=script&lang=js"
export * from "./PaymentMethodModal.vue?vue&type=script&lang=js"

import "./PaymentMethodModal.vue?vue&type=style&index=0&id=3ae1c1b8&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ae1c1b8"]])

export default __exports__